/* eslint-disable jira/filename-case */
/* oxlint-disable no-restricted-properties */
import noop from 'lodash/noop';
import { getPerformance } from '@jira/ssr__browser-globals/src/getPerformance.tsx';

const getPerf = (): Performance => {
	try {
		// TODO - Write up an explanation to why we are doing this, if this method is approved.

		const browserPerformance = getPerformance();
		if (!browserPerformance) {
			throw new Error('Performance API is unavailable');
		}
		// oxlint-disable-next-line no-cond-assign
		browserPerformance.clearResourceTimings ? (browserPerformance.clearResourceTimings = noop) : '';

		return browserPerformance;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		// no op implementation
		return {
			now: () => 0,
			// @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'PerformanceMark'.
			mark: noop,
			clearMarks: noop,
			clearResourceTimings: noop,
			getEntriesByType: (_type: string) => [],
			getEntriesByName: (_name: string) => [],
			// @ts-expect-error - TS2322 - Type 'void' is not assignable to type 'PerformanceMeasure'.
			measure: (_measureName: string, _start: string, _end: string) => {
				/* empty */
			},
		};
	}
};
const perf: Performance = getPerf();
export default perf;
